<template>
  <div class="hero general-hero">
    <div class="flex-container container">
      <div class="left-container">
        <h1>Welcome to <b>DNA HOUSE</b></h1>
        <h3>Follow us around the world.</h3>
        <h5>DNA has presence at every major crypto event, year round.</h5>
        <div class="btn btn-alt-hero">
          <a href="#events">
            <button class="button">Events Lineup</button>
          </a>
        </div>
        <div class="btn btn-video">
          <button @click="openModal" class="btn">
            ▶ Watch Now!
          </button>
        </div>
        <div
          v-if="isModalOpen"
          class="modal-overlay"
          @click.self="closeModal"
        >
          <div class="modal-container">
            <button class="modal-close-btn" @click="closeModal">×</button>
            <iframe
              class="modal-video"
              :src="vimeoSrc"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
      <div class="right-container">
        <div class="video-wrapper">
          <iframe
            :src="vimeoEmbedSrc"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
        
        <!--<div class="photo-column first">
          <div class="photo-item horizontal">
            <img :src="getImageUrl(photos[0].src)" :alt="photos[0].alt" />
          </div>
          <div class="photo-item vertical">
            <img :src="getImageUrl(photos[1].src)" :alt="photos[1].alt" />
          </div>
        </div>
        <div class="photo-column">
          <div class="photo-item vertical">
            <img :src="getImageUrl(photos[2].src)" :alt="photos[2].alt" />
          </div>
          <div class="photo-item horizontal">
            <img :src="getImageUrl(photos[3].src)" :alt="photos[3].alt" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onUnmounted } from 'vue';

const isModalOpen = ref(false);

const VIMEO_ID = '1107262053';

const vimeoSrc =
  `https://player.vimeo.com/video/${VIMEO_ID}` +
  `?autoplay=1` +
  `&loop=1` +
  `&background=1` +
  `&muted=0`;

const vimeoEmbedSrc = 
  `https://player.vimeo.com/video/${VIMEO_ID}` +
  `?background=1`;

function openModal() {
  isModalOpen.value = true;
}
function closeModal() {
  isModalOpen.value = false;
}

watch(isModalOpen, (open) => {
  document.body.style.overflow = open ? 'hidden' : '';
});

onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>

<style lang="scss">
@import "../../styles/import/variables.scss";
@import "../../styles/import/mixins.scss";

.hero {
  padding: 150px 0 100px;
  background-color: $alt-dark;
  @include upto ($breakpoint_sm) {
    padding: 100px 0 20px;
  }
}

.agenda-btn {
  margin-bottom:15px;
  @include upto ($breakpoint_sm) {
    margin-bottom: 10px;
  }
  button.hero-agenda {
    padding: 10px 20px;
  }
}

.general-hero {
  .btn {
    width: 250px;
    button {
      width: 100%;
    }
  }
}

.flex-container {
  display: flex;
  gap: 80px;
  width: 100%;
  height: auto;
  @include upto ($breakpoint_md) {
    flex-direction: column;
    gap: 40px;
  }
}

.left-container {
  flex: .7;
}

.right-container {
  flex: 1;
}

.left-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  h1 {
    color: $white;
    font-size: 64px;
    font-weight: 500;
    margin: 0 0 25px 0;
    line-height: 1.2;
    @include upto($breakpoint_lg) {
      font-size: 54px;
    }
    @include upto($breakpoint_sm) {
      font-size: 36px;
    }
  }
  h3 {
    color: $white;
    font-size: 32px;
    font-weight: 400;
    margin: 0;
    line-height: 1.2;
    @include upto($breakpoint_lg) {
      font-size: 28px;
    }
    @include upto($breakpoint_sm) {
      font-size: 22px;
    }
  }
  h5 {
    color: $white;
    opacity: .7;
    font-size: 24px;
    font-weight: 300;
    margin: 10px 0 20px;
    line-height: 1.2;
    @include upto($breakpoint_lg) {
      font-size: 21px;
    }
    @include upto($breakpoint_sm) {
      font-size: 18px;
    }
  }
}

.right-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
  align-items: center; 
}

.photo-column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 50%; 
  &.first {
    position: relative;
    top: 65px;
    box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.6);
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100px;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgb(5 9 15) 100%);
      pointer-events: none;
    }
  }
}

.photo-item {
  overflow: hidden;
  border-radius: 0.5rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.photo-item.horizontal {
  height: 200px;
  @include upto ($breakpoint_md) {
    height: 100px;
  }
}

.photo-item.vertical {
  height: 400px;
  @include upto ($breakpoint_md) {
    height: 200px;
  }
}

.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  position: relative;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  aspect-ratio: 16 / 9;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}
.modal-video {
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
}

.modal-close-btn {
  position: absolute;
  top: 8px; right: 8px;
  background: rgba(255,255,255,0.9);
  border: none;
  font-size: 1.2rem;
  line-height: 1;
  width: 32px; height: 32px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1001;
}

.video-wrapper {
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  aspect-ratio: 16 / 9;
  background: #000;
  overflow: hidden;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
